import React from 'react';

const EntityInvestAdvisers = ({ formData, handleChange, fieldErrors }) => {
    const hideSectionsCD =
        formData.entityInvestmentDetails.investmentCompanyEntity === 'false' &&
        formData.entityInvestmentDetails.businessDevelopEntity === 'false';

    return (
        <>
            <h4>
                *Note the ability to give a response of “True” to each of questions (b), (c), and (d) below that apply qualifies the Subscriber as a “qualified client” under the Investment Advisers Act.*
            </h4>

            <fieldset className="form-field">
                <legend>(a) The Subscriber is:</legend>

                <legend className="question_indent">
                    (1) an entity which is registered as an “investment company” under the Investment Company Act, or which would be an “investment company” as defined in Section 3(a) of the Investment Company Act if it were not exempt from such definition due to Section 3(c)(1) of the Investment Company Act
                </legend>
                <label className="subChoice_indent">
                    <input type="radio" name="entityInvestmentDetails.investmentCompanyEntity" value="true" checked={formData.entityInvestmentDetails.investmentCompanyEntity === 'true'} onChange={handleChange} required/>
                    True
                </label>
                <br />
                <label className="subChoice_indent">
                    <input type="radio" name="entityInvestmentDetails.investmentCompanyEntity"  value="false"  checked={formData.entityInvestmentDetails.investmentCompanyEntity === 'false'} onChange={handleChange} />
                    False
                </label>

                <legend className="question_indent space-after">
                    (2) a “business development company” as defined in Section 202(a)(22) of the Investment Advisers Act
                </legend>
                <label className="subChoice_indent">
                    <input type="radio" name="entityInvestmentDetails.businessDevelopEntity" value="true" checked={formData.entityInvestmentDetails.businessDevelopEntity === 'true'} onChange={handleChange} required/>
                    True
                </label>
                <br />
                <label className="subChoice_indent">
                    <input type="radio" name="entityInvestmentDetails.businessDevelopEntity" value="false" checked={formData.entityInvestmentDetails.businessDevelopEntity === 'false'} onChange={handleChange} />
                    False
                </label>
            </fieldset>

            {(
            formData.entityInvestmentDetails.investmentCompanyEntity !== 'true' &&
            formData.entityInvestmentDetails.businessDevelopEntity !== 'true'
            ) && (
            <fieldset className="form-field">
                <div id="entityInvestmentDetailsScrollAnchor" tabIndex={-1} />
                <legend>
                (b) If the Subscriber answered “False” to each part of Part III(a) above, the Subscriber              
                </legend>
                <legend>
                <span className='question_indent'>
                    (i) has a net worth in excess of $2,200,000, 
                </span><br/>
                <span className='question_indent'>
                    (ii) is a “qualified purchaser” as defined in Section 2(a)(51)(A) of the Investment Company Act, or 
                </span><br/>
                <span className='question_indent'>
                    (iii) is making a commitment to the Fund of at least $1,100,000 or, immediately after making a contribution to the Fund, will have at least $1,100,000 under the management of the Management Company.
                </span>
                </legend>
                <label className="subChoice_indent">
                    <input
                        type="radio"
                        name="entityInvestmentDetails.qualifiedClientNetWorth"
                        value="true"
                        checked={formData.entityInvestmentDetails.qualifiedClientNetWorth === "true"}
                        onChange={handleChange}
                        required
                    />
                    True
                </label>
                <br />
                <label className="subChoice_indent">
                    <input
                        type="radio"
                        name="entityInvestmentDetails.qualifiedClientNetWorth"
                        value="false"
                        checked={formData.entityInvestmentDetails.qualifiedClientNetWorth === "false"}
                        onChange={handleChange}
                    />
                    False
                </label>

                {fieldErrors?.entityInvestmentAdvisers && (
                <div className="error-message" style={{ color: 'red', fontWeight: 'bold', marginTop: '0.5rem' }}>
                    {fieldErrors.entityInvestmentAdvisers}
                </div>
                )}

            </fieldset>
            )}


            {!hideSectionsCD && (
            <fieldset className="form-field">
                <legend>
                (c) If the Subscriber answered “True” to any part of Part III(a) above (a “Look-Through Entity”), each equity owner of the Subscriber 
                </legend>
                <legend>
                <span className='question_indent'>
                    (i) has a net worth (including, for natural persons, assets held jointly with such person’s spouse) in excess of $2,200,000, excluding, for natural persons, the value of the primary residence of such person, calculated by subtracting from the estimated fair market value of the property the amount of debt secured by the property up to the estimated fair market value of the property,
                </span><br/>
                <span className='question_indent'>
                    (ii) is a “qualified purchaser” as defined in Section 2(a)(51)(A) of the Investment Company Act, or
                </span><br/>
                <span className='question_indent'>
                    (iii) is making a direct or indirect commitment to the Fund of at least $1,100,000 or, immediately after directly or indirectly making a contribution to the Fund, will have at least $1,100,000 under the management of the Management Company.
                </span>                   
                </legend>
                <label className="subChoice_indent">
                <input
                    type="radio"
                    name="entityInvestmentDetails.lookThroughEntityOwnerNetWorth"
                    value="true"
                    checked={formData.entityInvestmentDetails.lookThroughEntityOwnerNetWorth === "true"}
                    onChange={handleChange}
                    required
                />
                True
                </label>
                <br />
                <label className="subChoice_indent">
                <input
                    type="radio"
                    name="entityInvestmentDetails.lookThroughEntityOwnerNetWorth"
                    value="false"
                    checked={formData.entityInvestmentDetails.lookThroughEntityOwnerNetWorth === "false"}
                    onChange={handleChange}
                />
                False
                </label>
            </fieldset>
            )}

            {!hideSectionsCD && (
            <fieldset className="form-field">
                <legend>
                (d) If the Subscriber is a Look-Through Entity and any direct or indirect equity owner of the Subscriber is also a Look-Through Entity, each equity owner of such direct or indirect equity owner 
                </legend>
                <legend>
                <span className='question_indent'>
                    (i) has a net worth (including, for natural persons, assets held jointly with such person’s spouse) in excess of $2,200,000, excluding, for natural persons, the value of the primary residence of such person, calculated by subtracting from the estimated fair market value of the property the amount of debt secured by the property up to the estimated fair market value of the property,
                </span><br/>
                <span className='question_indent'>
                    (ii) is a “qualified purchaser” as defined in Section 2(a)(51)(A) of the Investment Company Act, or
                </span><br/>
                <span className='question_indent'>
                    (iii) is making a direct or indirect commitment to the Fund of at least $1,100,000 or, immediately after directly or indirectly making a contribution to the Fund, will have at least $1,100,000 under the management of the Management Company.
                </span>
                </legend>
                <label className="subChoice_indent">
                <input
                    type="radio"
                    name="entityInvestmentDetails.lookThroughIndirectOwnerNetWorth"
                    value="true"
                    checked={formData.entityInvestmentDetails.lookThroughIndirectOwnerNetWorth === "true"}
                    onChange={handleChange}
                    required
                />
                True
                </label>
                <br />
                <label className="subChoice_indent">
                <input
                    type="radio"
                    name="entityInvestmentDetails.lookThroughIndirectOwnerNetWorth"
                    value="false"
                    checked={formData.entityInvestmentDetails.lookThroughIndirectOwnerNetWorth === "false"}
                    onChange={handleChange}
                />
                False
                </label>
            </fieldset>
            )}
        </>
    );
};

export default EntityInvestAdvisers;
